import Axios from 'axios';
export const getAddress = async (lat, lng) => {
    const address = {};
    try {
        const { data } = await Axios.get(
            `https://maps.google.com/maps/api/geocode/json?latlng=${lat},${lng}&sensor=true&rankby=distance&key=AIzaSyCtIZ0E4yzvGqwBYXiNv9DxqvMRqeI3_pg`
        );
        if (data.results[0].formatted_address) {
            address.address = data.results[0].formatted_address;
        }
        if (data.status === 'OK') {
            data.results[0].address_components.map(address => {
                if (address.types.includes('country')) {
                    address.country = address.long_name;
                } else if (address.types.includes('postal_code')) {
                    address.pincode = address.long_name;
                } else if (
                    address.types.includes('administrative_area_level_1')
                ) {
                    address.state = address.long_name;
                } else if (
                    address.types.includes('administrative_area_level_2') ||
                    address.types.includes('locality')
                ) {
                    address.city = address.long_name;
                }
            });
        }
        return address;
    } catch (e) {
        return {};
    }
};



// WEBPACK FOOTER //
// ./src/utils/helpers/functions/geocode.js